import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";
import image1 from "../../assets/banner2.jpg";
import image2 from "../../assets/banner4.jpg";
import image3 from "../../assets/banner1.jpg";

export default function ServiceBeans() {
  return (
    <>
      <ServiceDetailPage
        label="Flatdeck"
        title="General Cargo Transportation: Flatdeck"
        subtitle="Cargo transportation using flatdeck trailers for goods requiring structured loading, secure fastening, and efficient long-haul movement."
        overview="Our flatdeck service is suited for packaged materials, project cargo, and industrial freight that needs stable platform transport and disciplined delivery handling."
        images={[
          {
            src: image1,
            alt: "Flatdeck transport",
            captionTitle: "Flatdeck Capacity",
            captionText: "Heavy cargo movement with secure load arrangement.",
          },
          {
            src: image2,
            alt: "Cargo route",
            captionTitle: "Long-Haul Readiness",
            captionText: "Route operations for domestic and regional transport.",
          },
          {
            src: image3,
            alt: "Cargo delivery",
            captionTitle: "Delivery Discipline",
            captionText: "Reliable offloading support at client destinations.",
          },
        ]}
        highlights={[
          "Flatdeck trailer units for general and project cargo.",
          "Secure load planning and route-based transport execution.",
          "Suitable for industrial, construction, and commercial goods.",
        ]}
        metrics={[
          { value: "Flatdeck", label: "Trailer configuration" },
          { value: "Secure", label: "Load management method" },
          { value: "Long-Route", label: "Distance capability" },
        ]}
      />
      <Footer />
    </>
  );
}
